module.exports = __webpack_public_path__ + "img/126.99e1243d.jpg";